export default __webpack_public_path__ + "static/media/WWYK.f7708616.gif";